"use strict";
var ko = require("knockout");
var _ = require("lodash");
var ajaxUtils_1 = require("../app/utils/ajaxUtils");
var componentViewModels = {'androidBuy': require('./components/androidBuy.js'),'likeButton': require('./components/likeButton.js'),'litmobFavoriteButton': require('./components/litmobFavoriteButton.js'),'mobileAddToLibraryButton': require('./components/mobileAddToLibraryButton.js'),'mobileBuyButton': require('./components/mobileBuyButton.js'),'mobileChatRemoveButton': require('./components/mobileChatRemoveButton.js'),'mobileCommentForm': require('./components/mobileCommentForm.js'),'mobileCommentSubscription': require('./components/mobileCommentSubscription.js'),'mobileCopyCurrentUrlButton': require('./components/mobileCopyCurrentUrlButton.js'),'mobileFeedbackForm': require('./components/mobileFeedbackForm.js'),'mobileHideButton': require('./components/mobileHideButton.js'),'mobileIgnoreListButton': require('./components/mobileIgnoreListButton.js'),'mobileInputPassword': require('./components/mobileInputPassword.js'),'mobileLibraryButton': require('./components/mobileLibraryButton.js'),'mobileMarkButton': require('./components/mobileMarkButton.js'),'mobileModerateCommentForm': require('./components/mobileModerateCommentForm.js'),'mobileNotifications': require('./components/mobileNotifications.js'),'mobileSubToCollectionButton': require('./components/mobileSubToCollectionButton.js'),'mobileSubToSeriesButton': require('./components/mobileSubToSeriesButton.js'),'mobileSubscribeButton': require('./components/mobileSubscribeButton.js'),'mobileVideoPlayer': require('./components/mobileVideoPlayer.js'),'mobileWidget': require('./components/mobileWidget.js')};
var componentLoader = {
    getConfig: function (name, callback) {
        var componentName = _.camelCase(name);
        var viewModelConstructor = componentViewModels[componentName];
        if (viewModelConstructor === undefined) {
            throw new Error("Unable to find view model for component \"" + componentName + "\"");
        }
        callback({
            viewModel: {
                createViewModel: function (params, componentInfo) {
                    var viewModel = new viewModelConstructor.default(params, componentInfo.element, componentInfo.templateNodes);
                    var appComponentName = _.upperFirst(componentName);
                    window["AppComponents"][appComponentName] = viewModel;
                    return viewModel;
                }
            },
            template: { fromUrl: componentName },
            synchronous: true
        });
    },
    loadTemplate: function (name, templateConfig, callback) {
        if (templateConfig.fromUrl) {
            ajaxUtils_1.AjaxUtils.getTemplate(templateConfig.fromUrl).done(function (result) {
                if (_.isString(result)) {
                    ko.components.defaultLoader.loadTemplate(name, result, callback);
                }
            });
        }
        else {
            callback(null);
        }
    }
};
ko.components.loaders.unshift(componentLoader);
//# sourceMappingURL=componentLoader.js.map